function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}
export default memoize;
if (typeof memoize !== 'undefined' && memoize && memoize === Object(memoize) && Object.isExtensible(memoize) && !Object.prototype.hasOwnProperty.call(memoize, '__filemeta')) {
  Object.defineProperty(memoize, '__filemeta', {
    configurable: true,
    value: {
      name: "memoize",
      filename: "node_modules/gatsby-theme-docz/node_modules/@emotion/memoize/dist/memoize.browser.esm.js"
    }
  });
}